

















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class MenuList extends Vue {
  constructor() {
    super();
  }
  public index = "1";
  @Prop()
  menuId:any
  @Watch("menuId", { deep: true })
  watchCount(newVal: any) {
    // if (newVal == "/home") {
    //   this.index = "1";
    // } else if (newVal == "/enterPrise") {
    //   this.index = '4';
    // } else if (newVal == "/cdCar") {
    //   this.index == '2';
    // } else if (newVal == "/cdOrder") {
    //   this.index == '3';
    // }
    console.log("newVal", newVal);
  }

  public isCollapse = false;
  handleSelect(key: any, keyPath: any) {
    console.log(key, keyPath);
  }
  handleOpen(key: any, keyPath: any) {
    console.log(key, keyPath);
  }
  handleClose(key: any, keyPath: any) {
    console.log(key, keyPath);
  }
}
